export const ticketTypes = [
  {
    label: "Shipment",
    value: "Shipment",
  },
  {
    label: "Quote",
    value: "Quote",
  },
  {
    label: "General Issue",
    value: "General Issue",
  },
];

export const ticketPriorities = [
  {
    label: "Urgent",
    value: "Urgent",
  },
  {
    label: "High",
    value: "High",
  },
  {
    label: "Medium",
    value: "Medium",
  },
  {
    label: "Low",
    value: "Low",
  },
];
